import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricOtherReasonCount extends MetricBase {
    constructor() {
        super({
            field: "metric_otherReasonCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.otherReasonCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.otherReasonCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.otherReasonCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricOtherReasonCount;
